import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { IoMdGift } from 'react-icons/io';
import bg from "../../../Assets/images/card.svg"

const FoodCard = ({ index, image, mealType, title, body, price }) => {
  return (
<Box sx={{background:`url('${bg}')`, backgroundSize:'cover',height:'300px',mb:3, backgroundPosition:'center',borderRadius:'19px', cursor:'pointer' }}>
<Box sx={{display:'flex', flexDirection:'column', justifyContent:'space-between', height:'100%', }}>
  <Box></Box>
  <Box sx={{p:3, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
    <Box >
      <Typography sx={{fontFamily:'optima', fontSize:'24px', color:'#1C3F77', fontWeight:700}}>{title}</Typography>
      <Typography sx={{ fontSize:'14px', color:'primary.main',fontWeight:500, mt:0.5 }}>{price}</Typography>
    </Box>
    <Box>
      <Typography sx={{color:'#1C3F77', fontWeight:700, fontSize:'12px'}}>GIFT CARD</Typography>
    </Box>
  </Box>
</Box>
</Box>
  );
};

export default FoodCard;
